import { api } from '.';

export interface RiskLevel {
    id: number;
    name: string;
    max: number;
    color: string;
    colorSecondary: string;
    riskProfileId: number;
    description: string;
  }
  
  export interface RiskProfile {
    id: number;
    name: string;
    riskLevels: RiskLevel[];
    isTemplate: boolean;
    customerId: number;
  }  

  const riskProfileApi = api.injectEndpoints({
    endpoints: builder => ({
      getRiskProfileById: builder.query<RiskProfile, number>({
        query: id => `RiskProfile/${id}`,
        transformResponse: (response: { data: RiskProfile }) => response.data,
        providesTags: ['RiskProfile'],
      }),
    }),
  });
  
  export const { useGetRiskProfileByIdQuery, useLazyGetRiskProfileByIdQuery } = riskProfileApi;
